// @flow

import createAction from 'redux-actions/lib/createAction';

// -----------------------------------------------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------------------------------------------

type DisplayPersonalisedDataClearedMessageActionType = 'PERSONAL_CONTENT:DISPLAY_PERSONALISED_DATA_CLEARED_MESSAGE';

export type DisplayPersonalisedDataClearedMessageAction = {|
  type: DisplayPersonalisedDataClearedMessageActionType,
  payload: {||},
  meta: {||},
|};


// -----------------------------------------------------------------------------------------------------------------
// Constants
// -----------------------------------------------------------------------------------------------------------------

const type: DisplayPersonalisedDataClearedMessageActionType = 'PERSONAL_CONTENT:DISPLAY_PERSONALISED_DATA_CLEARED_MESSAGE';


// -----------------------------------------------------------------------------------------------------------------
// Action
// -----------------------------------------------------------------------------------------------------------------

const displayPersonalisedDataClearedMessage: (void) => DisplayPersonalisedDataClearedMessageAction = createAction(type);


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default displayPersonalisedDataClearedMessage;



// WEBPACK FOOTER //
// ./src/modules/personalContent/store/actions/displayPersonalisedDataClearedMessage.js